import React from 'react';
import { Box, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Dropzone from 'dashboard/components/upload';

/**
 * Tab 1 — brand logo upload. Drag-and-drop dropzone with a styled
 * empty-state. The actual file is held by the parent so it can be
 * appended to the multipart submit alongside the JSON payload.
 */
export default function LogoTab({ logoFile, onLogoUpload }) {
  return (
    <Dropzone
      onFileUploaded={onLogoUpload}
      file={logoFile}
      content={
        <Box>
          <CloudUploadIcon sx={{ width: 80, height: 80 }} color='action' />
          <Typography variant='h6' fontWeight='700' mb='12px' whiteSpace='pre-wrap'>
            Drop your logo here, or{' '}
            <Box component='span' sx={{ color: 'primary.main', fontWeight: 700 }}>
              browse
            </Box>
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            PNG, JPG and GIF files are allowed
          </Typography>
        </Box>
      }
    />
  );
}
